import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductById, fetchProducts } from "../../Redux/slice/productSlice";
import {  useNavigate , useParams} from "react-router-dom";
import { Button, Tabs, Modal, Card, message} from "antd";
import { ShoppingCartOutlined, CheckCircleFilled } from "@ant-design/icons";
import { addToCart } from "../../Redux/slice/cartSlice";
import { FacebookOutlined, WhatsAppOutlined, ShareAltOutlined } from "@ant-design/icons";
import ProductDetailSkeleton from "./ProductDetailSkeleton";
import { Helmet } from "react-helmet";

const formatPrice = (price) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const ProductDetail = () => {
  const { productID } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentProduct = useSelector((state) => state.products.currentProduct);
  const { products, loading } = useSelector((state) => state.products);
  const cartItems = useSelector((state) => state.cart.cart);
  const cartId = useSelector((state) => state.cart.cartId);

  const [isImageModalVisible, setImageModalVisible] = useState(false);
  const [isShareModalVisible, setShareModalVisible] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [viewedProducts, setViewedProducts] = useState([]);

  useEffect(() => {
    dispatch(fetchProducts()); // Fetch products
    dispatch(fetchProductById(productID)); // Fetch current product by ID
    window.scrollTo(0, 0); // Scroll to top on page load
  }, [dispatch, productID]);
  useEffect(() => {
    if (currentProduct && currentProduct.length > 0) {
      const product = currentProduct[0];
      const viewed = {
        id: product.productID, // Ensure correct ID is stored
        name: product.productName, // Ensure correct name is stored
        price: product.price,
        image: `https://smfteapi.salesmate.app/Media/Products_Images/${product.productImage.split("\\").pop()}`,
      };
  
      const existingViewed = JSON.parse(localStorage.getItem("viewedProducts")) || [];
      const updatedViewed = existingViewed.filter((item) => item.id !== viewed.id);
      updatedViewed.unshift(viewed);
      localStorage.setItem("viewedProducts", JSON.stringify(updatedViewed.slice(0, 4))); 
      setViewedProducts(updatedViewed.slice(0, 4));
    }
  }, [currentProduct]);
  

  useEffect(() => {
    const storedViewed = JSON.parse(localStorage.getItem("viewedProducts")) || [];
    setViewedProducts(storedViewed);
  }, []);

  const recentProducts = products.slice(-12); // Get the last 12 products as related products
  

  const handleAddToCart = () => {
    // Check if the product is already in the cart
   
    const isProductInCart = cartItems.some(
      (item) => item.productID === currentProduct[0].productID
    );
  
    if (isProductInCart) {
      message.warning('Product is already in the cart.');
      return;
    }
  
    setIsAddingToCart(true);
    const cartData = {
      cartId,
      productID: currentProduct[0].productID,
      price: currentProduct[0].price,
      quantity: 1,
    };
  
    dispatch(addToCart(cartData))
      .then(() => {
        message.success('Product added to cart successfully!');
      })
      
      .catch((error) => {
        message.error(`Failed to add product to cart: ${error.message}`);
      })
      .finally(() => {
        setIsAddingToCart(false);
      });
     
      
      // Send event to Google Tag Manager
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: currentProduct[0].productName,
              item_id: currentProduct[0].productID,
              price: currentProduct[0].price,
              quantity: 1,
            }
          ]
        }
      });
  
  };
  const productUrl = window.location.href; // Get the current product URL
 
  
  const renderViewedProducts = () => {
    if (!viewedProducts || viewedProducts.length === 0) return null;
    return (
      <div className="mt-8">
        


        <div className="w-full bg-green-700 py-2 px-4 rounded-lg mb-4">
          <h2 className="text-sm font-semibold text-white">Viewed Products</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {viewedProducts.map((product) => (
  <Card
    key={product.productID}
    hoverable
    className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-lg w-full group"
    cover={
      <div
      onClick={() => {
        if (!product || !product.id) {
          return;
        }
        navigate(`/product/${product.id}`);
      }}
      
      className="cursor-pointer relative"
    >
        <div className="h-32 md:h-32 lg:h-48 flex items-center justify-center mb-3">
          <img
            src={product.image}
            alt={product.name}
            className="w-32 md:w-24 lg:w-48 object-cover rounded-lg"
          />
        </div>
      </div>
    }
  >
    <Card.Meta
      title={<p className="font-semibold text-xs sm:text-sm line-clamp-2">{product.name}</p>}
      description={<p className="text-red-500 font-bold text-xs sm:text-sm">₵{formatPrice(product.price)}.00</p>}
    />
  </Card>
))}
 </div>
      </div>
    );
  };
  // Share logic for Facebook
  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`,
      '_blank'
    );
  };

  // Share logic for WhatsApp
  const handleWhatsAppShare = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(productUrl)}`,
      '_blank'
    );
  };

  const handleStickyButton = () => {
    if (window.scrollY > 200) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleStickyButton);
    return () => {
      window.removeEventListener("scroll", handleStickyButton);
    };
  }, []);
  

  if (loading) {
    return <ProductDetailSkeleton />;

  }
if (!currentProduct || currentProduct.length === 0) {
    return<ProductDetailSkeleton />;
}


  const product = currentProduct[0];
  const backendBaseURL = "https://smfteapi.salesmate.app";
  const imageUrl = `${backendBaseURL}/Media/Products_Images/${product.productImage.split("\\").pop()}`;

  const productDescription = product.description.split("\n").map((text, index) => (
    <p key={index} className="mb-4">{text}</p>
  ));
  
  

  const renderRelatedProducts = () => {
    if (!recentProducts || recentProducts.length === 0) return null;
    return (
      <div className="mt-8 mb-12">
        <div className="w-full bg-green-700 py-2 px-4 rounded-md mb-2">
          <h2 className="text-sm font-semibold text-white">
    For You
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {recentProducts.map((product) => (
            <Card
              key={product.productID}
              hoverable
              className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-lg w-full group"
              cover={
                <div onClick={() => {
                  if (!product || !product.productName) {
                    console.error("Product or productName is undefined:", product);
                    return;
                  }
             
                  navigate(`/product/${product.productID}`);
                }}
                 className="cursor-pointer relative">
                  {product.oldPrice > 0 && (
                    <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold rounded-full px-2 py-1">
                    </div>
                  )}
                  <div className="h-32 md:h-32 lg:h-48 flex items-center justify-center mb-3">
                    <img
                      src={`https://smfteapi.salesmate.app/Media/Products_Images/${product.productImage
                        .split("\\")
                        .pop()}`}
                      alt={product.productName}
                      className="w-32 md:w-24 lg:w-48 object-cover rounded-lg"
                    />
                  </div>
                </div>
              }
            >
              <Card.Meta
                title={<p className="font-semibold text-xs sm:text-sm line-clamp-2">{product.productName}</p>}
                description={
                  <div className="mt-1">
                    <p className="text-red-500 font-bold text-xs sm:text-sm">{`₵${formatPrice(product.price)}`}.00</p>
                    {product.oldPrice > 0 && (
                      <p className="text-gray-500 text-xs line-through sm:inline-block md:flex">
                        {`₵${formatPrice(product.oldPrice)}`}.00
                      </p>
                    )}
                  </div>
                }
              />
              <Button
                shape="circle"
                icon={<ShoppingCartOutlined />}
                className="absolute bottom-2 right-2 bg-red-500 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToCart(product);
                }}
              />
            </Card>
          ))}
        </div>
      </div>
    );
  };
  

  return (
    <div>


<Helmet>
  <title>{`${product?.productName || "Product"} - Best Price`}</title>
  <meta name="description" content={`Buy ${product?.productName || "this product"} for ₵${formatPrice?.(product?.price) || "0.00"}. High-quality and best prices available.`} />
  <meta property="og:title" content={product?.productName || "Product"} />
  <meta property="og:description" content={`Buy ${product?.productName || "this product"} for ₵${formatPrice?.(product?.price) || "0.00"}.`} />
  <meta property="og:image" content={imageUrl || "default-image-url.jpg"} />
  <meta property="og:url" content={productUrl || "https://frankotrading.com"} />
  <meta name="twitter:card" content="summary_large_image" />
  <link rel="canonical" href={`https://frankotrading.com/product/${product?.productID || "defaultID"}`} />
</Helmet>

<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.productName,
    "image": imageUrl,
    "description": product.description,
    "sku": product.productID,
    "brand": {
      "@type": "Brand",
      "name": product.brandName
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "GHS",
      "price": product.price,
      "priceValidUntil": "2025-12-31",
      "itemCondition": "https://schema.org/NewCondition",
     "availability": "https://schema.org/InStock",
      "url": `https://frankotrading.com/product/${product.productID}`,
      "seller": {
        "@type": "Organization",
        "name": "Franko Trading"
      },
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "currency": "GHS",
          "value": "30.00"
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "GH"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 2,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 3,
            "maxValue": 5,
            "unitCode": "DAY"
          }
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 14,
        "returnMethod": "https://schema.org/ReturnByMail",
        "returnFees": "https://schema.org/FreeReturn", 
        "applicableCountry": "GH"
      },
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.5",
      "reviewCount": "120"
    },
    "review": {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "John Doe"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      }
    }
  })}
</script>


    <div className="max-w-7xl mx-auto p-4">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Column - Product Image */}
        <div className="lg:w-1/2 bg-white">
          <img
            src={imageUrl}
            alt={product.productName}
            className="rounded-lg shadow-lg cursor-pointer"
            onClick={() => setImageModalVisible(true)}
            style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "5px" }}
          />
        </div>

        {/* Right Column - Product Info */}
        <div className="lg:w-1/2">
          <h1 className="text-lg md:text-2xl font-bold mb-4">{product.productName}</h1>
          <div className="bg-red-100 p-2 rounded-lg inline-block mb-2">
            <span className="text-2xl font-bold">₵{formatPrice(product.price)}.00</span>
            {product.oldPrice > 0 && (
              <span className="line-through text-gray-500 ml-8">
                ₵{formatPrice(product.oldPrice)}.00
              </span>
            )}
          </div>

          <div className="space-y-4 mb-2 bg-gray-50 p-4 rounded-lg">
            <div className="flex items-center gap-2">
              <CheckCircleFilled className="text-green-500" />
              <span className="font-medium">Availability:</span>
              <span className="text-green-500">In Stock</span>
            </div>
          </div>

          <Tabs
            items={[
              {
                key: "1",
                label: <span style={{ color: "red" }}>Product Description</span>,
                children: (
                  <div className="p-4" style={{ maxHeight: "250px", overflowY: "auto" }}>
                    {productDescription}
                  </div>
                ),
              },
            ]}
          />

          {/* Add to Cart Button and Share */}
          <div className="hidden lg:flex flex-row items-center gap-6 mt-6 mb-4">

{/* Add to Cart Button */}
<button
  disabled={isAddingToCart}
  onClick={handleAddToCart}
  className={`flex items-center gap-2 text-white px-6 py-2 rounded-full shadow-md transition-all duration-300 
    ${isAddingToCart ? "bg-red-300 cursor-not-allowed" : "bg-red-500 hover:bg-red-600"}`}
>
  <ShoppingCartOutlined className="text-lg" />
  {isAddingToCart ? "Adding..." : "Add to Cart"}
</button>

<button
  size="large"
  className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-full shadow transition-all duration-300 flex items-center"
  onClick={() => {
    const phoneNumber = "233246422238";
    const message = encodeURIComponent(
      `Hello! I'm interested in this product and would like to know more details:\n\n` +
      `🛒 *Product Name:* ${product.productName}\n` +
      `💬 Please let me know more about its features, availability, and pricing. Thank you!`
    );

    // 🔽 Push the GTM event to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "chat_with_sales",
      channel: "WhatsApp",
      product: {
        item_name: product.productName,
        item_id: product.productID,
        price: product.price
      }
    });

    // 🔽 Open WhatsApp chat
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  }}
>
  <img
    src="https://img.icons8.com/color/24/000000/whatsapp--v1.png"
    alt="WhatsApp"
    className="mr-2"
  />
  Chat with Sales
</button>


<Button
  icon={<ShareAltOutlined style={{ marginRight: "10px" }} />}
  size="large"
  className=" text-blue-300 px-6 py-2 rounded-full shadow transition-all duration-300"
  onClick={() => setShareModalVisible(true)}
>
 
</Button>
</div>

        </div>
      </div>
      {renderViewedProducts()}
      {/* Related Products */}
      {renderRelatedProducts()}

      {/* Image Modal */}
      <Modal
        visible={isImageModalVisible}
        footer={null}
        onCancel={() => setImageModalVisible(false)}
        width={800}
      >
        <img src={imageUrl} alt={product.productName} className="w-full h-auto object-contain" />
      </Modal>

      {/* Share Modal */}
      <Modal
        title="Share this product"
        visible={isShareModalVisible}
        onCancel={() => setShareModalVisible(false)}
        footer={null}
      >
        <div className=" md:ml-4 flex flex-col justify-center mt-4 gap-4">
          <Button
            icon={<FacebookOutlined />}
            size="large"
            onClick={handleFacebookShare}
       className="flex items-center bg-blue-600 text-white"   >
            Share on Facebook
          </Button>
          <Button
            icon={<WhatsAppOutlined />}
            size="large"
            onClick={handleWhatsAppShare}
       className="flex items-center bg-green-800 text-white"   >
            Share on WhatsApp
          </Button>
        </div>
      </Modal>
       {/* Sticky Add to Cart Button on Mobile */}
       <div className="fixed bottom-0 left-0 right-0 bg-white p-2 shadow-lg z-50 lg:hidden">
  <div className="flex justify-between items-center gap-2">
    {/* Add to Cart Button */}
    <Button
      icon={<ShoppingCartOutlined style={{ fontSize: "16px" }} />}
      size="middle"
      className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded-md w-[45%]"
      onClick={handleAddToCart}
      loading={isAddingToCart}
    >
      Add to cart
    </Button>

    {/* WhatsApp Enquire Button */}
    <button
      className="bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded-md w-[45%] flex items-center justify-center gap-1 shadow-sm transition-all duration-300"
      onClick={() => {
        const phoneNumber = "233246422238";
        const message = encodeURIComponent(
          `Hello! I'm interested in this product and would like to know more details:\n\n` +
          `🛒 *Product Name:* ${product.productName}\n` +
          `💬 Please let me know more about its features, availability, and pricing. Thank you!`
        );
    
        // 🔽 Push the GTM event to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "chat_with_sales",
          channel: "WhatsApp",
          product: {
            item_name: product.productName,
            item_id: product.productID,
            price: product.price
          }
        });
    
        // 🔽 Open WhatsApp chat
        window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
      }}
    >
      <img
        src="https://img.icons8.com/color/20/000000/whatsapp--v1.png"
        alt="WhatsApp"
      />
      Chat
    </button>

    {/* Share Button */}
    <Button
      icon={<ShareAltOutlined style={{ fontSize: "16px" }} />}
      shape="circle"
      size="middle"
      className="text-blue-500 border-none"
      onClick={() => setShareModalVisible(true)}
    />
  </div>
</div>


    </div>

    </div>
    
  );
};

export default ProductDetail;